import {ShapeCommand} from '../../commands.template';
import * as _ from 'lodash';

export class FlowlineDeleteInteractionCommand extends ShapeCommand {
  services: any;
  reverseData: any;

  constructor(data) {
    super(data);
  }

  public prepareData() {
    return this;
  }

  public execute() {
    super.execute();
    const graph = this.services.editorRegistrySvc.getGraph();
    const index = _.findIndex(this.services.jsonHandlerSvc.get().interactions, (ia: any) => {
      return Number(ia.flowlineMxKey) === Number(this.object.flowlineMxKey);
    });
    const interactionData = this.services.jsonHandlerSvc.get().interactions[index];

    this.reverseData = {...interactionData, index};

    const interactionCell = graph.model.getCell(`${this.object.flowlineMxKey}-ian`);

    graph.removeCells([interactionCell], false);

    const action = {
      deleteInteraction: {
        flowlineMxKey: Number(this.object.flowlineMxKey)
      }
    };

    this.services.diagramUpdateSvc.update(action);
    this.services.graphHelperSvc.redrawInteractions(
      this.services.jsonHandlerSvc.get().interactions
    );
  }

  public reverse() {
    super.reverse();
    const graph = this.services.editorRegistrySvc.getGraph();
    const edge = graph.model.getCell(this.object.flowlineMxKey);
    const lineJson = edge.getJson();
    const value = this.reverseData.index + 1;

    const interactionCell = this.services.shapeSpawnerSvc.createInteractionCell(
      this.reverseData,
      value,
      lineJson
    );

    graph.addCell(interactionCell, edge);

    const action = {
      createInteraction: {
        flowlineMxKey: Number(this.object.flowlineMxKey),
        offset: this.reverseData.offset,
        description: this.reverseData.description,
        style: this.reverseData.style,
        index: this.reverseData.index
      }
    };

    this.services.diagramUpdateSvc.update(action);
    this.services.graphHelperSvc.redrawInteractions(
      this.services.jsonHandlerSvc.get().interactions
    );
  }
}
